import { render } from "./SvgChannelPorts.vue?vue&type=template&id=7be9706c&ts=true"
import script from "./SvgChannelPorts.vue?vue&type=script&lang=ts"
export * from "./SvgChannelPorts.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__